<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="地区" prop="locations">
      <a-select
        mode="multiple"
        v-model="form.data.locations"
        multiple
        placeholder="请选择">
        <a-select-option
          v-for="item in location.data"
          :key="item"
          :title="item"
          :value="item">
          {{ item }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="首重" prop="baseWeight">
      <a-input-number v-model="form.data.baseWeight"/>
    </a-form-model-item>
    <a-form-model-item label="运费" prop="postage">
      <a-input-number v-model="form.data.postage"/>
    </a-form-model-item>
    <a-form-model-item label="续重" prop="unitWeight">
      <a-input-number v-model="form.data.unitWeight"/>
    </a-form-model-item>
    <a-form-model-item label="续费" prop="unitPostage">
      <a-input-number v-model="form.data.unitPostage"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!transportInfoId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="transportInfoId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryTransportInfo,
  _addTransportInfo,
  _updateTransportInfo,
} from '@/api/transportInfoApi';

async function getTransportInfo() {
  const result = await _queryTransportInfo(this.transportInfoId);
  if (result) {
    this.form.data.locations = result.locations ? result.locations.split(',') : [];
    this.form.data.baseWeight = result.baseWeight;
    this.form.data.postage = result.postage;
    this.form.data.unitWeight = result.unitWeight;
    this.form.data.unitPostage = result.unitPostage;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addTransportInfo({
        locations: this.form.data.locations.join(','),
        baseWeight: this.form.data.baseWeight,
        postage: this.form.data.postage,
        unitWeight: this.form.data.unitWeight,
        unitPostage: this.form.data.unitPostage,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateTransportInfo(this.transportInfoId, {
        locations: this.form.data.locations.join(','),
        baseWeight: this.form.data.baseWeight,
        postage: this.form.data.postage,
        unitWeight: this.form.data.unitWeight,
        unitPostage: this.form.data.unitPostage,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      };
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'TransportInfoEdit',
  props: {
    transportInfoId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    transportInfoId() {
      if (this.transportInfoId) {
        this.getTransportInfo();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getTransportInfo,
  },
  data() {
    return {
      location: {
        data: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区', '台湾省', '香港特别行政区', '澳门特别行政区'],
      },
      form: {
        data: {
          locations: [],
          baseWeight: 0,
          postage: 0,
          unitWeight: 0,
          unitPostage: 0,
        },
        rules: {
          locations: [{ required: true, trigger: 'blur' }],
          baseWeight: [{ required: true, trigger: 'blur' }],
          postage: [{ required: true, trigger: 'blur' }],
          unitWeight: [{ required: true, trigger: 'blur' }],
          unitPostage: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.transportInfoId) {
      this.getTransportInfo();
    }
  },
};
</script>
